import { keywordActions } from "../../actionTypes";

const initialState = {
	keywordsById: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case keywordActions.FETCH_KEYWORDS_BY_ID: {
			return { ...state, ...initialState };
		}

		case keywordActions.FETCH_KEYWORDS_BY_ID_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				keywordsById: action.payload.data,
			};
		}

		case keywordActions.FETCH_KEYWORDS_BY_ID_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
